import React, { useRef, useEffect } from "react";
import { Toast } from "bootstrap";
import { useNavigate } from "react-router";

const ToastAlert = ({ message, header }) => {
  const navigate = useNavigate();
  const toastRef = useRef();
  useEffect(() => {
    var myToast = toastRef.current;
    var bsToast = new Toast(myToast);
    bsToast.show();
  }, []);
  const hideToast = () => {
    var myToast = toastRef.current;
    var bsToast = Toast.getInstance(myToast);
    bsToast.hide();
  };
  return (
    <div className="toast" role="alert" data-bs-delay="5000" ref={toastRef}>
      <div className="toast-header">
        <img
          // This is hardcoded need to eliminate this
          src="https://res.cloudinary.com/dszd4owdm/image/upload/v1706378273/Group_1_2_edc8hi.png"
          className="rounded-circle me-2"
          style={{ height: 25, width: 25, zIndex: 30 }}
        ></img>
        <strong className="me-auto">ReShup</strong>
        <small>just now</small>
        <button
          type="button"
          className="btn-close"
          onClick={() => hideToast()}
        ></button>
      </div>
      <div className="toast-body p-0">
        <div class="p-3 text-center">
          <h5 class="mb-0">{header}</h5>
          <p class="mb-0">{message}</p>
        </div>
        {/* <div class="modal-footer flex-nowrap p-0">
          <button
            type="button"
            class="btn btn-lg btn-link fs-6 text-decoration-none col-6 m-0 rounded-0 border-end"
            onClick={() => navigate("/profile/information")}
          >
            <strong>View settings</strong>
          </button>
          <button
            type="button"
            class="btn btn-lg btn-link fs-6 text-decoration-none col-6 m-0 rounded-0"
            onClick={() => hideToast()}
          >
            Dismiss
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default ToastAlert;
